import { useHasPermission } from "../../auth/useClaims";

// Vehicle Master (handoff §20.1) - standard page-wise Create/Edit/View
// triad (§13.3), no all-branch check (server already branch-scopes reads/
// writes the same way Customers/Products/Employees do).
//
// 2026-09-10: Vehicles.ApproveRequest now HAS a hook - approving a submitted
// maintenance request moved into React (Pending Vehicle Requests), because a
// manager previously had to open the Flutter app to approve one even though
// both endpoints had existed server-side since Batch40.
// Vehicles.CreateRequest/.ViewRequests/.ViewAllRequests are still unused here:
// requests are raised in Flutter by the person who needs the work done.
export const useCanCreateVehicles = () => useHasPermission("Vehicles.Create");
export const useCanEditVehicles = () => useHasPermission("Vehicles.Edit");
export const useCanApproveVehicleRequests = () => useHasPermission("Vehicles.ApproveRequest");
